import * as ko from "knockout";
import * as _ from "underscore";
import { App } from "../../app";
import { Api } from "../../app-api";
import * as m from "./register-models";
import { ViewModel as root } from "../register";

export class ChooseAllocations extends m.Form {
    availableOnly = ko.observable(false);
    filter = ko.observable<m.Filter>();

    allocations = ko.observableArray<m.Allocation>();

    filteredAllocations: ko.Computed<m.Allocation[]>;

    showAll: () => void;
    showAvailableOnly: () => void;

    constructor(root: root) {
        super(root);
        let self = this;

        self.id = m.FormEnum.Allocations;
        self.heading = "Select Available Program";

        self.filter(new m.Filter(root));
        self.unFilled(new m.UnFilled("Choose Available programs"));

        self.filteredAllocations = ko.computed(() => {
            var results = self.availableOnly() ?
                _(self.allocations()).filter(x => x.available) :
                self.allocations();

            var filter = self.filter().selected();

            return _(filter).any() ?
                _(results).filter(x => x.filter(filter)) :
                results
        }, self);//.extend({ throttle: 300 });

        self.next().enabled = ko.pureComputed(() => {
            return _(root.selectedAllocations()).any();
        }, self);

        self.next().selected = ko.pureComputed(() => {
            return _(root.selectedAllocations()).reduce((sum, x) => { return sum + x.qty() }, 0);
        }, self);

        self.unFilled().display = ko.pureComputed(() => {
            return !(self.active() || _(root.selectedAllocations()).any());
        }, self);

        self.active.subscribe(newVal => {
            if (newVal && !_(self.allocations()).any())
                self.searchCamps(root);
        });

        self.busy.subscribe(newVal => {
            App.busy(newVal);
        });

        self.filteredAllocations.subscribe(changes => {
            self.showing().showing(changes.length);
        });

        self.allocations.subscribe(changes => {
            self.showing().of(changes.length);
        });

        self.back = () => {
            root.chooseSkillLevels().show();
        }

        self.next().next = () => {
            if (!self.next().enabled()) { return false; }
            self.register(root);
        }

        self.refresh = () => {
            if (!self.busy())
                self.searchCamps(root);
        }

        self.showAll = () => {
            self.availableOnly(false);
        }

        self.showAvailableOnly = () => {
            self.availableOnly(true);
        }

        App.onEnter("#allocationsSection .list-container", self.next().next);
    }

    private register(root: root) {
        let self = this;

        self.busy(true);

        const data = {
            registrations: _(root.selectedAllocations()).map(x => (
                {
                    allocation: x.toJson(),
                    qty: x.qty()
                }))
            };

        Api.Register(data)
            .done(results => {
                if (results.error) { App.alertError(results.message); return; }
                window.location.href = results.nextUrl;
            })
            .always(() => self.busy(false));
    }

    private searchCamps(root: root) {
        let self = this;

        //console.log("searchCamps");

        //_(root.chooseLocations().locations()).each(x => console.log(x.id));

        self.busy(true);

        self.allocations.removeAll();

        var data = {
            locations: _(root.selectedLocations()).map(x => x.id),
            skillLevels: _(root.selectedSkillLevels()).map(x => x.id)
        }

        Api.SearchCamps(data)
            .done(results => {
                if (Api.NoResults("No Search Camps Results", results)) { return; }

                self.filter().filter(results.filter);

                var temp = self.allocations();

                _(results.allocations).each(x => {
                    temp.push(new m.Allocation(x, root));
                });

                self.allocations.valueHasMutated();
            })
            .always(() => self.busy(false));
    }
}